var catNav = document.getElementById('support-cat-nav');

if (catNav) {
  var catName = document.getElementById('category-header-name'),
    headerHabitat = document.getElementById('header-habitat'),
    catDropdown = document.getElementById('support-nav__dropdown--toggle'),
    catLogo = document.getElementById('support-nav__header-logo'),
    catSearch = document.getElementById('support-nav__nav-search'),
    promoBar = document.getElementById('promo-notification'),
    searchSupportV2 = document.getElementById('search-support-v2'),
    catCaret = document.getElementById('support-nav__dropdown--caret'),
    catNavLinks = document.getElementById('support-nav__nav-links'),
    catSearchdiv = document.getElementById('support-nav__nav-searchdiv'),
    catSearchClose = document.getElementById('support-nav__nav-close'),
    pageWrapper = document.getElementById('page__wrapper'),
    stickyNavTop = 0,
    flagSearchNav = 0,
    catNavHide = catNav.classList.contains("support-nav__nav--hide");
    
  window.addEventListener(
    'scroll',
    function (e) {
      searchSupportV2 = document.getElementById('search-support-v2');
      stickyNavTop = stickyNavTop ? stickyNavTop: searchSupportV2.offsetTop + searchSupportV2.offsetHeight;

      if (window.innerWidth >= 980) {
        //Secondary Navigation
        if (window.scrollY >= stickyNavTop) {
          catNav.classList.add('sticky-header');
          catLogo.classList.add('active');
          catSearch.classList.add('active');
          headerHabitat.classList.add('header-habitat--swipe-top');

          if (catNavHide) {
            catNav.classList.remove('support-nav__nav--hide');
          } else {
            pageWrapper.style.paddingTop = catNav.offsetHeight + "px";
          }
        } else {
          catNav.classList.remove('sticky-header');
          catLogo.classList.remove('active');
          catSearch.classList.remove('active', 'hide');
          if (catNavLinks) {
            catNavLinks.classList.remove('active');
          }
          catSearchdiv.classList.remove('active');
          headerHabitat.classList.remove('header-habitat--swipe-top');

          if (catNavHide) {
            catNav.classList.add('support-nav__nav--hide');
          } else {
            pageWrapper.style.paddingTop = "0";
          }

          catSearchClose.classList.remove('active');
        }

        //active class
        if (catSearchdiv.classList.contains('active') && !flagSearchNav) {
          catSearchdiv.classList.remove('active');
        }
      } else {
        var topicsDivWrapper = document.querySelector('.faq-support-v2__recent-topics-wrapper');

        //Responsive
        if (window.pageYOffset >= stickyNavTop - 63) {
          catSearchdiv.classList.add('active');
          catNav.classList.add('sticky-header');
          pageWrapper.style.paddingTop = catNav.offsetHeight - 63 + "px";

          if ((topicsDivWrapper && topicsDivWrapper.classList.contains("faq-support-v2__recent-topics-wrapper-toggleshow"))) {
            topicsDivWrapper.classList.add('sticky-header');
          }
        } else if ((topicsDivWrapper && !topicsDivWrapper.classList.contains("faq-support-v2__recent-topics-wrapper-toggleshow"))
        || !topicsDivWrapper) {
          catNav.classList.remove('sticky-header');
          pageWrapper.style.paddingTop = "0";
          catSearchdiv.classList.remove('active');
        } else if ((topicsDivWrapper && topicsDivWrapper.classList.contains("faq-support-v2__recent-topics-wrapper-toggleshow"))
        || !topicsDivWrapper) {
          catNav.classList.remove('sticky-header');
          topicsDivWrapper.classList.remove('sticky-header');
          pageWrapper.style.paddingTop = "0";
          catSearchdiv.classList.remove('active');
        } else {
          pageWrapper.style.paddingTop = "0";
        }
      }
    },
    false
  );

  //Category Dropdown
  catDropdown.addEventListener('click', function (e) {
    e.preventDefault();
    catDropdown.classList.toggle('active');
    if (catNavLinks) {
      catNavLinks.classList.toggle('active');
    }
  });

  //Link Click WebTracker Event
  var catLinks = catNav.querySelectorAll('a');
  for (var i = 0; i < catLinks.length; i++) {
    catLinks[i].addEventListener('click', function (e) {
      if (catNavLinks) {
        catNavLinks.classList.remove('active');
      }
      catDropdown.classList.remove('active');
    });
  }

  //Search Nav Click
  catSearch.addEventListener('click', function (e) {
    e.preventDefault();
    if (catNavLinks) {
      catNavLinks.classList.add('active');
    }
    flagSearchNav = 1;
    catSearchdiv.classList.add('active');
    catSearch.classList.add('hide');
    catSearchClose.classList.add('active');
  });

  //Search Nav Click
  catSearchClose.addEventListener('click', function (e) {
    e.preventDefault();
    if (catNavLinks) {
      catNavLinks.classList.remove('active');
    }
    flagSearchNav = 0;
    catSearchdiv.classList.remove('active');
    catSearch.classList.remove('hide');
    catSearchClose.classList.remove('active');
  });
}
